import { makeNullSafeDomainGetter, strictUnitDocSelector } from 'store/state/domainData/selectors/common';
import { flow } from 'lodash';

export const unitDocSelector = makeNullSafeDomainGetter(strictUnitDocSelector, 'docId2Information');
export const resolvedStrictUnitDocSelector = flow(unitDocSelector, (info) => info && info.document);

